import {
  championshipLeagues,
  UPCOMING_GAMES_ITEM,
  ROUTES,
  TODAYS_GAMES_LABEL,
  LIVE_EVENTS_LABEL,
} from 'constants';
import { DEFAULT_EVENTS_FEED } from 'constants/localStorageKey';
import React, { useCallback } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { allGamesResetAction } from 'redux/games/actionCreators.js';
import { useGetSortedLeaguesList } from 'hooks';
import useLocalStorage from 'hooks/useLocalStorage';
import { createSelectedValue } from 'helpers';
import { Selector } from 'components';

import { SelectContainer } from 'components/Header/style';

export const UpcomingGamesHeader = ({ leagues }) => {
  const dispatch = useDispatch();
  const { leaguesList, filteredLeagueList } = useGetSortedLeaguesList(leagues);

  const [searchParams, setSearchParams] = useSearchParams();
  const params = Object.fromEntries([...searchParams]);
  const navigate = useNavigate();
  // eslint-disable-next-line no-unused-vars
  const [defaultEventsFeed, setDefaultEventsFeed] = useLocalStorage(
    DEFAULT_EVENTS_FEED,
    LIVE_EVENTS_LABEL
  );

  const handleLeaguesChange = useCallback(
    (selectedLeague) => {
      const { value, label } = selectedLeague;

      if (championshipLeagues.includes(label)) {
        navigate(`/${ROUTES.CHAMPIONSHIPS}?league=${label}&leagueId=${value}`);
      } else if (label === TODAYS_GAMES_LABEL || label === LIVE_EVENTS_LABEL) {
        dispatch(allGamesResetAction());
        setSearchParams([]);
        setDefaultEventsFeed(label);
        navigate('/');
      } else {
        navigate(`/?league=${label}&leagueId=${value}`);
      }
    },
    [dispatch, navigate, setSearchParams, setDefaultEventsFeed]
  );

  const handleLeagueForTeamChange = useCallback(
    (selectedLeague) => {
      const { value, label } = selectedLeague;

      setSearchParams(
        (prevValue) => {
          prevValue.set('league', label);
          prevValue.set('leagueId', value);
          return prevValue;
        },
        { replace: true }
      );
    },
    [setSearchParams]
  );

  return (
    <SelectContainer>
      <Selector
        isDisabled={!leaguesList?.length}
        onChange={handleLeaguesChange}
        options={leaguesList}
        value={UPCOMING_GAMES_ITEM}
      />

      <Selector
        isDisabled={!filteredLeagueList?.length}
        onChange={handleLeagueForTeamChange}
        options={filteredLeagueList}
        placeholder="Select League..."
        value={createSelectedValue({
          value: params?.leagueId,
          label: params?.league,
        })}
      />
    </SelectContainer>
  );
};
